import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { GLOBAL } from "./global";
import { Methods } from "../shared/methods";

@Injectable({
  providedIn: "root",
})
export class PrincipalinventoryService {
  public mtds: Methods = new Methods();
  public url: string;
  public history: string;
  public token;
  public headers: HttpHeaders;
  public headers2: HttpHeaders;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url + "/inventory/";
    this.history = GLOBAL.url + "/inventory_history/";
    this.token = JSON.parse(localStorage.getItem("token"));
    if (this.token === "undefined") {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    this.headers2 = new HttpHeaders({
      "Content-Type": "text/plain",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  edit(id, json) {
    return this.petition(this.url + "detail/" + id, json);
  }

  updateItemMfgr(id, json) {
    return this.petition(this.url + "updateitemmfgr/" + id, json);
  }

  especificedit(id, json, type = "inventory") {
    switch (type) {
      case "history":
        return this.petition(this.history + "especificedit/" + id, json);
      default:
        return this.petition(this.url + "especificedit/" + id, json);
    }
  }

  showOne(id, type) {
    switch (type) {
      case "history":
        return this.petition(this.history + "detail/" + id);
      default:
        return this.petition(this.url + "detail/" + id);
    }
  }

  showByContainer(container_id, page = 1, perPage = 10, busqueda = "", filtros = []) {

    let url = GLOBAL.url + "/inventory/listbyweightitem/" + container_id + "?";

    let json = null;
    if (busqueda !== "") {
      json = {
        busqueda: busqueda,
      };
    }

    console.log(json);

    url = url + 'page=' + page + '&perpage=' + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;

        }
      }
    }

    return this.petition(
      url,
      json
    );
  }

  showByBatch(batch_id, page = 1, perPage = 10, busqueda = "", filtros = []) {

    let url = GLOBAL.url + "/inventory/listbybatch/" + batch_id + "?";

    let json = null;
    if (busqueda !== "") {
      json = {
        busqueda: busqueda,
      };
    }

    console.log(json);

    url = url + 'page=' + page + '&perpage=' + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;

        }
      }
    }

    return this.petition(
      url,
      json
    );
  }

  createForContainer(container_id, json) {
    return this.petition(`${this.url}addintoweightitem/${container_id}`, json);
  }

  createForBatch(batch_id, json) {
    return this.petition(`${this.url}addintobatch/${batch_id}`, json);
  }

  bulkChangesCheck(json) {
    return this.petition(`${this.url}bulkchangescheck`, json);
  }

  saveBulkChanges(json) {
    return this.petition(`${this.url}savebulkchanges`, json);
  }
  showAllOpti(
    page:any = 1,
    perPage:any = 10,
    busqueda = "",
    status = "",
    mfgr = "",
    grupos,
    sort = "",
    sortby = "",
    filtros = [],
    task:any,
    order:any
  ) {
    const json1 = {status_default : [task],order}
    let json = null; //grupos === 'ALL'
    if (busqueda !== "" && status === "" && mfgr === "" && grupos === "ALL") {
      json = {
        busqueda: busqueda,
      };
    } else if (
      busqueda !== "" &&
      status !== "" &&
      mfgr === "" &&
      grupos === "ALL"
    ) {
      console.log("holis");
      json = {
        busqueda: busqueda,
        filtertype: "status",
        filtervalue: status,
      };
    } else if (
      busqueda !== "" &&
      status === "" &&
      mfgr !== "" &&
      grupos === "ALL"
    ) {
      json = {
        busqueda: busqueda,
        filtertype: "mfgr",
        filtervalue: mfgr,
      };
    } else if (
      busqueda !== "" &&
      status !== "" &&
      mfgr !== "" &&
      grupos === "ALL"
    ) {
      json = {
        busqueda: busqueda,
        filtertype: "status",
        filtervalue: status,
        filtersecondtype: "mfgr",
        filtersecondvalue: mfgr,
      };
    } else if (
      busqueda === "" &&
      status !== "" &&
      mfgr !== "" &&
      grupos === "ALL"
    ) {
      json = {
        filtertype: "status",
        filtervalue: status,
        filtersecondtype: "mfgr",
        filtersecondvalue: mfgr,
      };
    } else if (
      busqueda === "" &&
      status !== "" &&
      mfgr === "" &&
      grupos === "ALL"
    ) {
      json = {
        filtertype: "status",
        filtervalue: status,
      };
    } else if (
      busqueda === "" &&
      status === "" &&
      mfgr !== "" &&
      grupos === "ALL"
    ) {
      json = {
        filtertype: "mfgr",
        filtervalue: mfgr,
      };
    } else if (
      busqueda === "" &&
      status === "" &&
      mfgr === "" &&
      grupos !== "ALL"
    ) {
      json = {
        groups: grupos,
      };
    } else if (
      busqueda !== "" &&
      status === "" &&
      mfgr === "" &&
      grupos !== "ALL"
    ) {
      json = {
        busqueda: busqueda,
        groups: grupos,
      };
    } else if (
      busqueda !== "" &&
      status !== "" &&
      mfgr === "" &&
      grupos !== "ALL"
    ) {
      console.log("holis");
      json = {
        busqueda: busqueda,
        filtertype: "status",
        filtervalue: status,
        groups: grupos,
      };
    } else if (
      busqueda !== "" &&
      status === "" &&
      mfgr !== "" &&
      grupos !== "ALL"
    ) {
      json = {
        busqueda: busqueda,
        filtertype: "mfgr",
        filtervalue: mfgr,
        groups: grupos,
      };
    } else if (
      busqueda !== "" &&
      status !== "" &&
      mfgr !== "" &&
      grupos !== "ALL"
    ) {
      json = {
        busqueda: busqueda,
        filtertype: "status",
        filtervalue: status,
        filtersecondtype: "mfgr",
        filtersecondvalue: mfgr,
        groups: grupos,
      };
    } else if (
      busqueda === "" &&
      status !== "" &&
      mfgr !== "" &&
      grupos !== "ALL"
    ) {
      json = {
        filtertype: "status",
        filtervalue: status,
        filtersecondtype: "mfgr",
        filtersecondvalue: mfgr,
        groups: grupos,
      };
    } else if (
      busqueda === "" &&
      status !== "" &&
      mfgr === "" &&
      grupos !== "ALL"
    ) {
      json = {
        filtertype: "status",
        filtervalue: status,
        groups: grupos,
      };
    } else if (
      busqueda === "" &&
      status === "" &&
      mfgr !== "" &&
      grupos !== "ALL"
    ) {
      json = {
        filtertype: "mfgr",
        filtervalue: mfgr,
        groups: grupos,
      };
    }

    let url = this.url + "listoptimization?page=" + page + "&perpage=" + perPage;
    if (sortby) {
      if (sort === "") {
        sort = "DESC";
      }
      url = url + "&order=" + sort + "&orderby=" + filtros[sortby].key;
    }

    for (let filtro of filtros) {      
      if (filtro && filtro.value) {
        console.log(filtro.key);
        url = url + "&" + filtro.key + "=" + encodeURIComponent(filtro.value);

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      } else if (filtro && filtro.value === '' && filtro.key === 'serialnumber' && filtro.type === 'equalto') {
        url = url + "&" + filtro.key + "=" + encodeURIComponent(filtro.value);

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      }
    }
    return this.petition(url, json1);
  }
  showAll(
    page = 1,
    perPage = 10,
    busqueda = "",
    status = "",
    mfgr = "",
    grupos,
    sort = "",
    sortby = "",
    filtros = []
  ) {
    let json = null; //grupos === 'ALL'
    if (busqueda !== "" && status === "" && mfgr === "" && grupos === "ALL") {
      json = {
        busqueda: busqueda,
      };
    } else if (
      busqueda !== "" &&
      status !== "" &&
      mfgr === "" &&
      grupos === "ALL"
    ) {
      console.log("holis");
      json = {
        busqueda: busqueda,
        filtertype: "status",
        filtervalue: status,
      };
    } else if (
      busqueda !== "" &&
      status === "" &&
      mfgr !== "" &&
      grupos === "ALL"
    ) {
      json = {
        busqueda: busqueda,
        filtertype: "mfgr",
        filtervalue: mfgr,
      };
    } else if (
      busqueda !== "" &&
      status !== "" &&
      mfgr !== "" &&
      grupos === "ALL"
    ) {
      json = {
        busqueda: busqueda,
        filtertype: "status",
        filtervalue: status,
        filtersecondtype: "mfgr",
        filtersecondvalue: mfgr,
      };
    } else if (
      busqueda === "" &&
      status !== "" &&
      mfgr !== "" &&
      grupos === "ALL"
    ) {
      json = {
        filtertype: "status",
        filtervalue: status,
        filtersecondtype: "mfgr",
        filtersecondvalue: mfgr,
      };
    } else if (
      busqueda === "" &&
      status !== "" &&
      mfgr === "" &&
      grupos === "ALL"
    ) {
      json = {
        filtertype: "status",
        filtervalue: status,
      };
    } else if (
      busqueda === "" &&
      status === "" &&
      mfgr !== "" &&
      grupos === "ALL"
    ) {
      json = {
        filtertype: "mfgr",
        filtervalue: mfgr,
      };
    } else if (
      busqueda === "" &&
      status === "" &&
      mfgr === "" &&
      grupos !== "ALL"
    ) {
      json = {
        groups: grupos,
      };
    } else if (
      busqueda !== "" &&
      status === "" &&
      mfgr === "" &&
      grupos !== "ALL"
    ) {
      json = {
        busqueda: busqueda,
        groups: grupos,
      };
    } else if (
      busqueda !== "" &&
      status !== "" &&
      mfgr === "" &&
      grupos !== "ALL"
    ) {
      console.log("holis");
      json = {
        busqueda: busqueda,
        filtertype: "status",
        filtervalue: status,
        groups: grupos,
      };
    } else if (
      busqueda !== "" &&
      status === "" &&
      mfgr !== "" &&
      grupos !== "ALL"
    ) {
      json = {
        busqueda: busqueda,
        filtertype: "mfgr",
        filtervalue: mfgr,
        groups: grupos,
      };
    } else if (
      busqueda !== "" &&
      status !== "" &&
      mfgr !== "" &&
      grupos !== "ALL"
    ) {
      json = {
        busqueda: busqueda,
        filtertype: "status",
        filtervalue: status,
        filtersecondtype: "mfgr",
        filtersecondvalue: mfgr,
        groups: grupos,
      };
    } else if (
      busqueda === "" &&
      status !== "" &&
      mfgr !== "" &&
      grupos !== "ALL"
    ) {
      json = {
        filtertype: "status",
        filtervalue: status,
        filtersecondtype: "mfgr",
        filtersecondvalue: mfgr,
        groups: grupos,
      };
    } else if (
      busqueda === "" &&
      status !== "" &&
      mfgr === "" &&
      grupos !== "ALL"
    ) {
      json = {
        filtertype: "status",
        filtervalue: status,
        groups: grupos,
      };
    } else if (
      busqueda === "" &&
      status === "" &&
      mfgr !== "" &&
      grupos !== "ALL"
    ) {
      json = {
        filtertype: "mfgr",
        filtervalue: mfgr,
        groups: grupos,
      };
    }

    let url = this.url + "listall?page=" + page + "&perpage=" + perPage;
    if (sortby) {
      if (sort === "") {
        sort = "DESC";
      }
      url = url + "&order=" + sort + "&orderby=" + filtros[sortby].key;
    }

    for (let filtro of filtros) {      
      if (filtro && filtro.value) {
        console.log(filtro.key);
        url = url + "&" + filtro.key + "=" + encodeURIComponent(filtro.value);

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      } else if (filtro && filtro.value === '' && filtro.key === 'serialnumber' && filtro.type === 'equalto') {
        url = url + "&" + filtro.key + "=" + encodeURIComponent(filtro.value);

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      }
    }
    return this.petition(url, json);
  }

  getInventoryHistory(page = 1, perPage = 10, busqueda = "") {
    const json = busqueda !== "" ? { busqueda } : null;
    return this.petition(
      GLOBAL.url +
        "/centrallog/listinventory?page=" +
        page +
        "&perpage=" +
        perPage,
      json
    );
  }

  getLogs(id, search) {
    const json = {
      type: "Inventory",
      search: search,
      idElement: id,
    };

    return this.petition(GLOBAL.url + "/centrallog/listbytype", json);
  }

  getLogsInventory(id, search,type){
    const json = {
      type: type,
      search: search,
      idElement: id,
    };

    return this.petition(GLOBAL.url + "/centrallog/listbytype", json);
  }

  testItem(id) {
    const json = {
      idElement: id,
    };

    return this.petition(this.url + "testitem", json);
  }

  testBulkItem(bulk, mark) {
    const json = {
      bulk: bulk,
      mark: mark,
    };

    return this.petition(this.url + "testbulkitem", json);
  }

  bulkContainer(bulk, container) {
    const json = {
      bulk: bulk,
      container: container,
    };

    return this.petition(this.url + "bulkcontainer", json);
  }

  bulkVirtualContainer(bulk, container) {
    const json = {
      bulk: bulk,
      container: container,
    };

    return this.petition(this.url + "bulkvirtualcontainer", json);
  }

  getAttributes(id, type) {
    const json = {
      id: id,
      type: type
    };

    return this.petition(this.url + "getattributes", json);
  }

  getpxe(sn) {
    const json = {
      sn: sn,
    };

    return this.petition(this.url + "getepspxe", json);
  }

  matchSN(sn, id) {
    const json = {
      sn: sn,
      id: id,
    };

    return this.petition(this.url + "matchserialnumber", json);
  }

  saveAttributes(json) {
    return this.petition(this.url + "saveattributes", json);
  }

  removeHardDrives(json) {
    return this.petition(this.url + "removeharddrives", json);
  }

  returnStatusHardDrives(json) {
    return this.petition(this.url + "returnstatusharddrives", json);
  }

  reportWithAttributes(json) {
    
    let url;

    if(json.type === 'pc')
      url = "https://itaderp.com/backend/reports/report-with-attributes-pc.php";
    else if (json.type === 'laptop')
      url = "https://itaderp.com/backend/reports/report-with-attributes-laptop.php";
    else if (json.type === 'switch')
      url = "https://itaderp.com/backend/reports/report-with-attributes-switch.php";
    else if (json.type === 'server')
      url = "https://itaderp.com/backend/reports/report-with-attributes-server.php";

    return this.petitionJson(
      url,
      json
    );
  }

  reportWithAttributesPO(json) {
    
    let url;

    if(json.type === 'pc')
      url = "https://itaderp.com/backend/reports/report-with-attributes-pc-po.php";
    else if (json.type === 'laptop')
      url = "https://itaderp.com/backend/reports/report-with-attributes-laptop-po.php";

    return this.petitionJson(
      url,
      json
    );
  }

  getWorkflow(json) {
    return this.petitionJson(
      "https://itaderp.com/backend/reports/report-workflow.php",
      json
    );
  }

  reportWithAttributesExtreme(json) {
    return this.petitionJson(
      "https://itaderp.com/backend/reports/report-with-attributes-extreme.php",
      json
    );
  }

  reportWithAttributesExtremeLaptop(json) {
    return this.petitionJson(
      "https://itaderp.com/backend/reports/report-with-attributes-extreme-laptop.php",
      json
    );
  }

  reportWithAttributesExtremeInventory(json) {
    return this.petitionJson(
      "https://itaderp.com/backend/reports/report-with-attributes-extreme-inventory.php",
      json
    );
  }

  removeAttributes(json) {
    return this.petition(this.url + "removeattributes", json);
  }

  petition(url, json = null, type = null) {
    let params = "authorization=" + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params + "&json=" + json;
    }

    if (type != null) {
      params = params + "&type=" + type;
    }

    return this._http.post(url, params, { headers: this.headers }).pipe(
      map((res: any) => {
        /*if (res.code === 404) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }*/
        return res;
      })
    );
  }

  petitionJson(url, json = null, type = null) {
    let paramas = json;

    return this._http
      .post(url, paramas, { headers: this.headers2, observe: 'response' })
      .pipe(
        map((res: any) => res),
        catchError((error) => {
          if (error.status === 404) {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
          return throwError(error);
        })
      );
  }
}
